import { render, staticRenderFns } from "./PaginationWidget.vue?vue&type=template&id=dc1b22ec&scoped=true&"
import script from "./PaginationWidget.vue?vue&type=script&lang=js&"
export * from "./PaginationWidget.vue?vue&type=script&lang=js&"
import style0 from "./PaginationWidget.vue?vue&type=style&index=0&id=dc1b22ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1b22ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
